<!-- This component is used to display the credit card form for the Sepio OAP Enrollment -->
<template>
	<div class="h-full w-full shrink-0">
		<component
			key="oap-cc-form"
			:is="connectStatus === 'online' ? OnlineCC : OfflineCC"
			:connectStatus="connectStatus"
			@connect="checkConnection"
		/>

		<OfflineCCForm key="oap-offline-form" />
	</div>
</template>

<script setup lang="ts">
import OfflineCCForm from './OfflineCCForm.vue'
import OnlineCC from './OnlineCC.vue'
import OfflineCC from '@/components/documents/PaymentStep/OfflineCC.vue'
import { nextTick, onMounted, ref } from 'vue'

const connectStatus = ref('online')

onMounted(async () => {
	await nextTick() // needed to prevent stripe form race condition
	checkConnection()
})

const checkConnection = () => {
	connectStatus.value = 'connecting'

	setTimeout(() => {
		if (navigator.onLine) {
			connectStatus.value = 'online'
		} else {
			connectStatus.value = 'error'
		}
	}, 500)
}
</script>
